import { fetchJsonRobust } from './fetch'
import type { WikiExtract } from '../../types'
import { wikiDomainFor } from '../../utils/text'

const GEO_LIMIT = 30

/**
 * Fetch Wikipedia POIs near a location
 */
export async function fetchWikiPOIs(
  domain: string,
  lat: number,
  lon: number,
  radius: number
): Promise<Array<{ pageid: number; title: string; lat: number; lon: number }>> {
  const geoUrl = `https://${domain}/w/api.php?action=query&list=geosearch&gscoord=${lat}|${lon}&gsradius=${radius}&gslimit=${GEO_LIMIT}&format=json&origin=*`
  const data = await fetchJsonRobust(geoUrl)
  return data?.query?.geosearch || []
}

/**
 * Fetch Wikipedia extract for a page ID
 */
export async function fetchWikiExtract(
  domain: string,
  pageid: number
): Promise<WikiExtract | null> {
  const pageUrl = `https://${domain}/w/api.php?action=query&prop=extracts&exintro=1&explaintext=1&pageids=${pageid}&format=json&origin=*`
  const pdata = await fetchJsonRobust(pageUrl)
  const page = pdata?.query?.pages?.[pageid]
  if (!page) return null
  return { title: page.title, extract: page.extract || '' }
}

/**
 * Fetch Wikipedia extract by title guess
 */
export async function fetchWikiExtractByTitleGuess(
  lang: string,
  titleGuess: string
): Promise<WikiExtract | null> {
  const domPrimary = wikiDomainFor(lang)
  const domFallback = 'en.wikipedia.org'

  async function trySearch(dom: string): Promise<WikiExtract | null> {
    const url = `https://${dom}/w/api.php?action=query&list=search&srsearch=${encodeURIComponent(titleGuess)}&srlimit=1&format=json&origin=*`
    const data = await fetchJsonRobust(url)
    const hit = data?.query?.search?.[0]
    if (!hit?.pageid) return null
    const ext = await fetchWikiExtract(dom, Number(hit.pageid))
    if (!ext?.extract) return null
    return ext
  }

  let hit = await trySearch(domPrimary)
  if (!hit && domPrimary !== domFallback) {
    hit = await trySearch(domFallback)
  }
  return hit
}
